export function dehydrate({ pk }) {
  return {
    pk,
  }
}

export function hydrate({ pk }) {
  return {
    pk,
  }
}
